import { forwardRef, InputHTMLAttributes } from "react";
import { Checkmark, Container, Input } from "./styles";

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement>;

const icon = (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7072 1.70711C12.0977 1.31658 12.0977 0.683417 11.7072 0.292893C11.3166 -0.0976311 10.6835 -0.0976311 10.293 0.292893L11.7072 1.70711ZM4.00004 8.00002L3.29294 8.70713C3.68346 9.09765 4.31662 9.09765 4.70715 8.70713L4.00004 8.00002ZM1.7071 4.29289C1.31658 3.90237 0.683414 3.90237 0.292891 4.2929C-0.0976323 4.68342 -0.0976299 5.31659 0.292896 5.70711L1.7071 4.29289ZM10.293 0.292893L3.29293 7.29291L4.70715 8.70713L11.7072 1.70711L10.293 0.292893ZM0.292896 5.70711L3.29294 8.70713L4.70715 7.29291L1.7071 4.29289L0.292896 5.70711Z"
      fill="currentColor"
    />
  </svg>
);

const Checkbox = forwardRef<HTMLLabelElement, CheckboxProps>(function Checkbox(
  props,
  ref
) {
  const { className, children, checked, disabled, ...rest } = props;
  return (
    <Container ref={ref} className={className} $disabled={disabled}>
      {children}
      <Input type="checkbox" {...rest} checked={checked} disabled={disabled} />
      <Checkmark>{icon}</Checkmark>
    </Container>
  );
});

// Cast to fix React 17 + @types/react 18 compatibility issue
export default Checkbox as any;
